<div class="mdc-layout-grid">
  <div class="mdc-layout-grid__inner">
    <div
      class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-phone">
      <bau365-toggle-watchlist-item
        class="eventsection-details__fullwidth"
        entityType="EVENT"
        [iconOnly]="false"
        [entityId]="event?.id"
        [pageContext]="'event-details'"
        [fairId]="event?.fair_id"></bau365-toggle-watchlist-item>
    </div>
    <div
      class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-phone">
      <button
        mat-flat-button
        color="primary"
        class="eventsection-details__fullwidth"
        (click)="openShareButtonDialog($event)">
        <mat-icon class="eventsection-details__actionicon">share</mat-icon>
        <span i18n="@@featureEventDetails-pageActions-share">Event teilen</span>
      </button>
    </div>
  </div>
</div>
<ng-template #shareButtonsTitle>
  <span i18n="@@featureExhibitorDetails-socialShareTitle">Teilen</span>
</ng-template>
<ng-template #shareButtons>
  <planone-share-buttons
    [url]="socialShareUrl"
    [emailSubject]="emailSubject"
    [emailBody]="emailBody"
    (shareButtonClicked)="shareButtonClick($event)"></planone-share-buttons>
</ng-template>
